import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../common/FormRenderer";
import { Button } from "react-bootstrap";
import { ACTIONS } from "../../../common/Constants";
import { ActivityType, CalendarType, GetActionTitle, Periodicity } from "../Master.constants";
import { useCreateActivity, useUpdateActivity } from "../../../../backend/masters";
import { toast } from "react-toastify";
import { ERROR_MESSAGES } from "../../../../utils/constants";
import PageLoader from "../../../shared/PageLoader"
import { ResponseModel } from "../../../../models/responseModel";

function AddEditActivity({ action, record : data, onClose, onSubmit }: any) {
    const [form, setForm] = useState<any>({});
    const [activity, setActivity] = useState<any>({ hideButtons: true })
    const { createActivity, creating } = useCreateActivity(({ key, value }: ResponseModel) => {
        if (activity && activity.error_messages.length > 0) {
            toast.error(activity.error_messages.join(', '));
        } else {
            toast.success(`"${activity.name}" created successfully.`);
            onSubmit();
        }
    }, errorCallback);
    const { updateActivity, updating } = useUpdateActivity((activity: ResponseModel) => {
        if (activity && activity.error_messages.length > 0) {
            toast.error(activity.error_messages.join(', '));
        } else {
            toast.success(`"${activity.name}" updated successfully.`);
            onSubmit();
        }
    }, errorCallback);

    const schema = {
        fields: [
            {
                component: componentTypes.INPUT_AS_TEXT,
                name: 'name',
                label: 'Activity',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: ''
            },
            {
                component: componentTypes.SELECT,
                name: 'type',
                label: 'Activity Type',
                options: ActivityType.map(x => {
                    return { id: x, name: x };
                }),
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: ''
            },
            {
                component: componentTypes.SELECT,
                name: 'periodicity',
                label: 'Periodicity',
                options: Periodicity.map(x => {
                    return { id: x, name: x };
                }),
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: ''
            },
            {
                component: componentTypes.SELECT,
                name: 'calendarType',
                label: 'Calendar Type',
                options: CalendarType.map(x => {
                    return { id: x, name: x };
                }),
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: ''
            }
        ]
    };

    function debugForm(_form: any) {
        setForm(_form);
        setActivity(_form.values);
    }

    function errorCallback() {
        toast.error(ERROR_MESSAGES.DEFAULT);
    }

    function handleSubmit() {
        if (form.valid) {
            const { name, type, periodicity, calendarType } = form.values;
            const payload: any = {
                name: name.trim(),
                activity_type: type.value,
                periodicity: periodicity.value,
                calendar_type: calendarType.value,
            };
            if (action === ACTIONS.ADD) {
                createActivity(payload);
            } else if (action === ACTIONS.EDIT) {
                payload['id'] = data.id;
                updateActivity(payload);
            }
        }
    }

    useEffect(() => {
        if (data) {
            const { name, activity_type, periodicity, calendar_type } = data;
            setActivity({
                ...activity,
                name,
                type: activity_type ? { value: activity_type, label: activity_type } : null,
                periodicity: periodicity ? { value: periodicity, label: periodicity } : null,
                calendarType: calendar_type ? { value: calendar_type, label: calendar_type } : null
            });
        }
    }, [data]);

    return (
        <>
            <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
                <Modal.Header closeButton={true} onHide={onClose}>
                    <Modal.Title className="bg">{GetActionTitle('Activity', action)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormRenderer FormTemplate={FormTemplate}
                        initialValues={activity}
                        componentMapper={ComponentMapper}
                        schema={schema}
                        debug={debugForm}
                    />
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    {
                      <>
                          <Button variant="outline-secondary" className="btn btn-outline-secondary px-4" onClick={onClose}>{'Cancel'}</Button>
                          <Button variant="primary" onClick={handleSubmit} className="px-4" disabled={!form.valid}>{'Submit'}</Button>
                      </>

                    }
                </Modal.Footer>
            </Modal>
            {
                (creating || updating) &&
                <PageLoader>
                    {creating ? 'Adding...' : 'Updating...'}
                </PageLoader>
            }
        </>
    )
}

export default AddEditActivity;
